module.exports = __webpack_public_path__ + "static/media/EventIconWhite.425341c7.png";